var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMicOffRedIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9959 8.482L15 6C15 4.34 13.66 3 12 3C10.34 3 9 4.34 9 6V12C9 12.6966 9.23596 13.3368 9.63251 13.8453L14.9959 8.482ZM8.05699 15.4209C7.225 14.5418 6.7 13.3639 6.7 12H5C5 13.7722 5.73037 15.3806 6.89057 16.5873L8.05699 15.4209ZM8.04155 17.5576L9.24243 16.3567C10.0641 16.8342 11.0182 17.1 12 17.1C14.76 17.1 17.3 15 17.3 12H19C19 15.42 16.28 18.24 13 18.72V22H11V18.72C9.92909 18.56 8.91788 18.1527 8.04155 17.5576ZM10.8334 14.7657L14.9923 10.6069L14.99 12C14.99 13.66 13.66 15 12 15C11.586 15 11.1918 14.9166 10.8334 14.7657Z",
    fill: "#FF5563"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2796 2.19637L2.18767 21.2883L0.59668 19.6973L19.6886 0.605383L21.2796 2.19637Z",
    fill: "#FF5563"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMicOffRedIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mic-off-red-icon.9eb69896.svg";
export { ForwardRef as ReactComponent };